import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification } from "antd";
import { Row, Form, Input, Col, Select, Collapse } from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  DeleteOutlined,
  FundViewOutlined,
  MinusCircleTwoTone,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import CompliantApi from "../../common/Apis/CompliantApi";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
const Complains = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Compliants, setCompliants] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(0);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [FilterEnable, setFilterEnable] = useState(true);
    const [formPaginate] = Form.useForm();
    const [totalElements, setTotalElements] = useState(0);

    // Initialize pagination form
    formPaginate.setFieldsValue({
      paginate: PaginateLimit,
    });


  const isSUPER_ADMIN = localStorage.getItem("isSUPER_ADMIN");
  
  const getCompliants = useCallback((page = 0, limit = PaginateLimit) => {
  CompliantApi.ListUserCompliants(decodedToken?.sub, page, limit)
    .then((response) => {
      console.log(response);
      settotalPages(response.totalPages || 0);
      setTotalElements(response.totalElements);
      setCompliants(response.payloadDto || []);
      setCurrentPage(page + 1);
      setPaginatePage(page);
    })
    .catch((err) => {
      console.log(err);
    });
}, [decodedToken?.sub, PaginateLimit]);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const handlePageChange = (page) => {
    if (page < 1 || page > PaginatetotalPages) return;
    setCurrentPage(page);
    let pageNew = page - 1;
    getCompliants(pageNew, PaginateLimit);
  };

  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({ paginate: value });
    getCompliants(0, value);
  };

  useEffect(() => {
    getCompliants();
    PageLoading();
  }, [getCompliants, PageLoading]);

  const handleDeleteCompliant = (CompliantID) => {
  CompliantApi.DeleteCompliant(CompliantID)
    .then((response) => {
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
        description: "Delete Successfully",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#b3ffb3",
          color: "green",
        },
      });
      // Refresh current page
      getCompliants(PaginatePage, PaginateLimit);
      PageLoading();
    })
    .catch((err) => {
      if (err.apiError.status) {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: err.apiError.message,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      }
    });
};

  const handleRemovefilterComplains = (FilterComplaintIndex) => {
    const newfilterComplaint = [...filterComplaint];
    newfilterComplaint.splice(FilterComplaintIndex, 1);
    setFilterComplaints(newfilterComplaint);
    if (FilterComplaintIndex == 0) {
      getCompliants();
    }
  };
  
  const handleClear = () => {
  setFilterEnable(true);
  setFilterComplaints([{ title: "", answerType: "", name: "" }]);
  getCompliants(0, PaginateLimit);
  setIsLoading(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 800);
};

  const formRef = useRef(null);

  const [filterComplaint, setFilterComplaints] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterComplaints = () => {
    setFilterComplaints([
      ...filterComplaint,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
  setFilterEnable(false);
  setIsLoading(true);
  
  let singleLineString = filterComplaint
    .map((obj) => {
      if (obj.answerType === "%") {
        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
      } else if (obj.answerType === "=") {
        return `${obj.title}${obj.answerType}${obj.name}`;
      } else {
        return `${obj.title}=BETWEEN${createDateTimestamp(
          obj.answerType
        )}AND${createDateTimestamp(obj.name)}`;
      }
    })
    .join("&");
  console.log(singleLineString);

  let filderData = window.btoa("componentCode=COMPLIANT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
  QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
    .then((response) => {
      setCurrentPage(1);
      setPaginatePage(0);
      settotalPages(response.totalPages || 0);
      setCompliants(response.payloadDto || []);
      setIsLoading(false);
    })
    .catch((err) => { 
      console.log(err);
      setIsLoading(false);
    });
};

  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (filterComplaintIndex, value) => {
    const newfilterComplaint = [...filterComplaint];
    newfilterComplaint[filterComplaintIndex].title = value;
    setFilterComplaints(newfilterComplaint);
  };
  const handleChangeAnswertype = (filterComplaintIndex, value) => {
    const newfilterComplaint = [...filterComplaint];
    newfilterComplaint[filterComplaintIndex].answerType = value;
    setFilterComplaints(newfilterComplaint);
  };

  const handleChangename = (filterComplaintIndex, value) => {
    const newfilterComplaint = [...filterComplaint];
    newfilterComplaint[filterComplaintIndex].name = value;
    setFilterComplaints(newfilterComplaint);
  };

  const paginatedData = Compliants;

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item.id} className="text-center">
          <td style={{ width: "35%" }} className="pt-3">
            {item?.customerCompliant.slice(0, 55)}
          </td>

          {decodedToken?.sub === "admin@admin.com" && (
            <td style={{ width: "20%" }} className="pt-3 text-center">
              {item?.tenantName}
            </td>
          )}
          <td style={{ width: "20%" }} className="pt-3">
            {new Date(item?.createdDate).toLocaleString()}
          </td>
          <td style={{ width: "20%" }}>
            <div className="d-flex ">
              <Link
                to={`/complaints/complaint-reply?id=${item?.id}${item?.tenantName ? `&TName=${item?.tenantName}` : ``
                  }`}
                className="btn btn-primary btn-save table-action icon-center w-100"
              >
                <FundViewOutlined />
                View
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Compliant ?"
                okText="Yes"
                onConfirm={() => handleDeleteCompliant(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_COMPLIANT'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={4} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
            />
            <br />
            {isSUPER_ADMIN !== "true" && (
              <div className="col-xl-12 col-lg-7 col-md-12 px-0 ">
                <Button
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'ADD_COMPLIANT'
                  ) ? 'btn btn-primary btn-save m-0 my-4' : 'd-none'}
                  href={"/complaints/create-complaint"}
                >
                  Create new feedback
                </Button>
              </div>
            )}
          </td>
        </tr>
      );
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterComplaint.map((input, filterComplaintIndex) => (
                    <div key={filterComplaintIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterComplaintIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterComplaintIndex, value)
                              }
                              options={[
                                {
                                  value: "customerCompliant",
                                  label: "Corrective Action / Maintenance Issue",
                                },

                                {
                                  value: "createdDate",
                                  label: "Created Date",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          {filterComplaint[filterComplaintIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterComplaintIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterComplaintIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterComplaintIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterComplaintIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={5}>
                          {filterComplaint[filterComplaintIndex].title ==
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterComplaintIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterComplaintIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterComplaintIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterComplaintIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterComplaintIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterComplaints}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterComplains(
                                      filterComplaintIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            {paginatedData?.length > 0 && (
              <>
                {isSUPER_ADMIN !== "true" && (
                  <div className="col-xl-12 col-lg-7 col-md-12 px-0 ">
                    <Button
                      href={"/complaints/create-complaint"}
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'ADD_COMPLIANT'
                      ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                    >
                      Create new
                    </Button>
                  </div>
                )}
              </>
            )}
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Corrective Action / Maintenance</th>
                  {decodedToken?.sub === "admin@admin.com" && (
                    <th className="text-center">Tenant Name</th>
                  )}
                  <th>Created Date </th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {Compliants.length > 0 && PaginatetotalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Complains;
